import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import '../../app/common/MediaQuery/responsive-tables.css';
import DynamicTableFrontEnd from '../DynamicTable/DynamicTableFrontEnd';

function ShelfRackMasterTable() {
  const {
    ShelfRackStore: { loadshelfRacks, HFCloadshelfRacks,  shelfRackitemsByDate,shelfRoomDetails,  loading },
    vaultStore: { vaultRegistry, loadVaults },
    commonStore: { hfcCustomerChanges },
  } = useStore();
  const [shelfRackTable, setShelfRackTable] = useState([]);
  const [roomShelfTable, setRoomShelfTable] = useState([]);


  useEffect(() => {
    hfcCustomerChanges ? HFCloadshelfRacks(): 
    loadshelfRacks();
         // eslint-disable-next-line
  }, [loadshelfRacks, HFCloadshelfRacks]);

  useEffect(() => {
    if (vaultRegistry.size <= 1) loadVaults();
  }, [vaultRegistry.size, loadVaults]);

  useEffect(() => {
    const removeCol =
      'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
    const tempShelfRackTable = JSON.parse(JSON.stringify(shelfRackitemsByDate));
    tempShelfRackTable.map((i: any) =>
      removeCol.split(',').map((j) => delete i[j]),
    );

    const HFCremovecol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
      const tempShelfRoomTable = JSON.parse(JSON.stringify(shelfRoomDetails));
      tempShelfRoomTable.map((i: any) =>
      HFCremovecol.split(',').map((j) => delete i[j]),
    );
    
    // if (hfcCustomerChanges) {
    //   const temp = tempShelfRackTable?.map((t: any) => {
    //     const obj = {
    //       ...t,
    //       pigeonHole: t.rackType,
    //     };
    //     delete obj.rackType;
    //     return obj;
    //   });
    //   setShelfRackTable(temp);
    // } else {
    setShelfRackTable(tempShelfRackTable);
    setRoomShelfTable(tempShelfRoomTable)
    // }
  }, [shelfRackitemsByDate, hfcCustomerChanges,shelfRoomDetails]);

  return (
    <>
      <div className="large-table-screen">
        <div className="small-table-screen">
          <Segment>
            <Header
              icon="list"
              size="huge"
              dividing
              as="h1"
              content={!hfcCustomerChanges ? "VIEW SHELF/RACKs": "VIEW ROOM/SHELFs"}
              sub
              color="grey"
            />
            <DynamicTableFrontEnd
              data={hfcCustomerChanges ? roomShelfTable: shelfRackTable }
              name={hfcCustomerChanges ? 'ShelfRoomTable': 'ShelfRackTable'}
              actiontype={hfcCustomerChanges? '':'editdel'}
              loading={!loadshelfRacks || loading}
            />
          </Segment>
        </div>
      </div>
    </>
  );
}

export default observer(ShelfRackMasterTable);
